import {
  DAY_LAPSED,
  TIME_LAPSED
} from 'libs/design-system/omega/src/constants/TimeLapsedConstants';

import { getTimeLapsedValues } from 'libs/design-system/omega/src/utils/TimeLapsedUtils';

import { degreeOptions, departmentOptions } from '@nw/shared/config';
import { getPreferredLanguageValueBasedOnEnum } from '@nw/shared/utils';

import {
  DATE_OF_BIRTH,
  DATE_PICKER,
  DEGREE,
  DEPARTMENT,
  PREFERRED_LANGUAGE,
  SELECT,
  SELECTED_GENDER
} from '../../constants/FieldTypeConstants';
import { DropdownOptionsType } from '../../types/FieldModelTypes';
import { RequestObjectExtraFieldsDataType } from '../../types/zodSchemaTypes';

export const getFieldInitialValueBasedOnFieldType = (
  type: string,
  userProfile: any,
  field,
  initialValue
) => {
  switch (type) {
    case DATE_PICKER:
      if (userProfile && field.field === DATE_OF_BIRTH) {
        return userProfile.dob;
      }
      return '';
    case SELECT:
      if (
        userProfile &&
        field.field === PREFERRED_LANGUAGE &&
        userProfile.preferredLanguages?.length > 0
      ) {
        const value = getPreferredLanguageValueBasedOnEnum(
          userProfile.preferredLanguages[0]
        );
        return value;
      } else if (userProfile && field.field === SELECTED_GENDER) {
        return userProfile.gender;
      }
      return initialValue;
    default:
      return initialValue;
  }
};

export const getFieldOptions = (dropDownField) => {
  switch (dropDownField.field) {
    case DEGREE:
      return degreeOptions;

    case DEPARTMENT:
      return departmentOptions;

    default:
      return [{ value: '', label: '' }];
  }
};

export const prepareOptions = (
  option: DropdownOptionsType | string
): DropdownOptionsType => {
  if (typeof option !== 'string' && 'label' in option && 'value' in option) {
    return {
      label: option.label,
      value: option.value
    };
  } else {
    return {
      label: option as string,
      value: option as string
    };
  }
};

export const getRadioOptions = (radioGroupFieldData) => {
  if (radioGroupFieldData.options_type === DAY_LAPSED) {
    const timeLapsedOptions = radioGroupFieldData.day_lapsed_options;

    const timeLapsedValues = getTimeLapsedValues({
      timeLapsedOptions,
      selectedDate: new Date()
    });
    return timeLapsedValues;
  } else if (radioGroupFieldData.options_type === TIME_LAPSED) {
    return radioGroupFieldData.time_lapsed_options;
  }
  return radioGroupFieldData.options;
};

export const getDefaultRadioOption = (radioGroupFieldData) => {
  if (radioGroupFieldData.options_type === DAY_LAPSED) {
    const timeLapsedOptions = radioGroupFieldData.day_lapsed_options;

    const timeLapsedValues = getTimeLapsedValues({
      timeLapsedOptions,
      selectedDate: new Date()
    });

    const defaultRadioOption = timeLapsedValues[0].value;

    return defaultRadioOption;
  }
  return radioGroupFieldData.defaultOption;
};

export const makeDropDown = (dropDownValue) => {
  if (dropDownValue && typeof dropDownValue === 'string') {
    return {
      value: dropDownValue,
      label: dropDownValue.toString()
    };
  } else if (dropDownValue && typeof dropDownValue === 'object') {
    return {
      value: dropDownValue.value,
      label: dropDownValue.label
    };
  }
  return {
    value: '',
    label: ''
  };
};

export const getFormattedRequestObjectKeys = (
  requestObjectExtraFieldData: RequestObjectExtraFieldsDataType
): Record<string, string> => {
  const formattedRequestObjectKeys: Record<string, string> = {};

  requestObjectExtraFieldData.forEach((eachField) => {
    if (eachField.field_name_in_request_object) {
      formattedRequestObjectKeys[eachField.field] =
        eachField.field_name_in_request_object;
    }
  });

  return formattedRequestObjectKeys;
};

export const getFormattedRequestObject = (
  requestObject: Record<string, any>,
  formattedRequestObjectKey: Record<string, string>
): Record<string, string> => {
  const formattedRequestObject: Record<string, string> = {};

  Object.keys(requestObject).forEach((eachKey) => {
    if (formattedRequestObjectKey[eachKey]) {
      formattedRequestObject[formattedRequestObjectKey[eachKey]] =
        requestObject[eachKey];
    }
  });
  return formattedRequestObject;
};
